import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/image';
import { Device, from, until } from '@helpers/media';
import { contentStyles } from '@helpers/typography';
import CtaLinkStyles from '@stories/Components/Buttons/CtaLink/CtaLink.styles';
import Image from '@stories/Components/Misc/Image/Image';
import styled from 'styled-components';
const Container = styled.article `
  --bgColor: ${brand.secondary.blueGrey};
  --borderColor: ${brand.lightBlue};
  --fgColor: ${brand.base.blue};

  display: flex;
  flex-direction: column;
  background-color: var(--bgColor);
  padding: ${fluid(16, 40)};
  border-radius: 10px;
  height: 100%;
`;
const TopWrapper = styled.div `
  display: grid;
  gap: ${fluid(14, 32)};
  margin: 0 0 ${fluid(24, 32)};
  color: var(--fgColor);

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: min(40%, 158px) 1fr;
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(158, 223)};

  max-width: 158px;
  border-radius: 5px;

  @media ${until(Device.TabletLarge)} {
    width: 40%;
  }
`;
const Img = styled(Image) `
  ${imageCoverContainer()}
`;
const ContentWrapper = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  color: var(--fgColor);
`;
const Date = styled.time `
  ${fonts.apparat.light};

  display: inline-block;
  font-size: ${fluid(12, 16)};
  line-height: ${fluid(26, 36)};
  margin: ${fluid(15, 24)} 0 0;
  text-transform: uppercase;
  opacity: 0.5;
`;
const Title = styled.h3 `
  ${fonts.apparat.semiBold};

  font-size: ${fluid(18, 22)};
  line-height: ${fluid(24, 32)};
  margin: 0;
`;
const Content = styled.div `
  ${transition('max-height', 1)};
  ${contentStyles};

  color: currentColor;
  margin: 0 0 ${fluid(20, 40)};

  p.large {
    ${fonts.apparat.semiBold};

    font-size: 20px;
    line-height: 32px;
  }

  p {
    font-size: ${fluid(16, 18)};
    line-height: ${fluid(26, 28)};
  }
`;
const ButtonsWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${fluid(18, 52)};
  border-top: 1px solid var(--borderColor);
  margin: auto 0 0;
  padding: ${fluid(20, 32)} 0 0;

  ${CtaLinkStyles.Container}[data-has-arrow='false'] {
    svg {
      width: 22px;

      path:nth-child(2) {
        ${transition('transform')};
      }
    }

    &:focus-visible,
    &:hover {
      svg path:nth-child(2) {
        transform: translateY(3px);
      }
    }
  }

  ${CtaLinkStyles.Container} {
    font-size: ${fluid(18, 20)};
    line-height: 26px;

    @media ${until(Device.TabletLarge)} {
      text-transform: uppercase;
    }
  }
`;
const MagazineCardStyles = {
    ButtonsWrapper,
    Container,
    Content,
    ContentWrapper,
    Date,
    ImageWrapper,
    Img,
    Title,
    TopWrapper,
};
export default MagazineCardStyles;
